// components/MenuCard.jsx

import React from "react";
import {
  Avatar,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

const MenuCard = ({
  title,
  subtitle,
  icon,
  onClick,
  badge,
  color = "#006D77",
  danger = false,
}) => {
  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2,
        mb: 2,
        cursor: "pointer",
        borderRadius: 3,
        border: "1px solid #ECECEC",
        transition: "all .25s ease",

        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 8px 22px rgba(0,0,0,.08)",
        },
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
      >
        {/* Icon */}

        <Avatar
          sx={{
            bgcolor: danger ? "#FEECEC" : `${color}15`,
            color: danger ? "#d32f2f" : color,
            width: 52,
            height: 52,
          }}
        >
          {icon}
        </Avatar>

        {/* Text */}

        <Box flex={1}>
          <Typography
            fontWeight={600}
            fontSize={16}
            color={danger ? "error.main" : "text.primary"}
          >
            {title}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              color="text.secondary"
              mt={0.5}
            >
              {subtitle}
            </Typography>
          )}
        </Box>

        {/* Badge */}

        {badge && (
          <Chip
            label={badge}
            size="small"
            sx={{
              bgcolor: "#E8F5E9",
              color: "#2E7D32",
              fontWeight: 600,
              mr: 1,
            }}
          />
        )}

        {/* Arrow */}

        <ChevronRightRoundedIcon
          sx={{
            color: "#999",
          }}
        />
      </Stack>
    </Paper>
  );
};

export default MenuCard;